/**
 * Rounds a price value to a specified number of decimal places
 * @param {number} value - The price value to round
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {number} Rounded value
 */
export const roundPrice = (value, decimals = 2) =>
  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
